export class Home365Constants {
  static readonly CustomErrorStatuses = [409];
  static ScreenSize = {
    mobileSmall: 400,
    mobile: 600,
    tablet: 991,
    lapTop: 1364
  };
  static readonly marginUnit = 8;
  static AnimationDuration = '220ms';
  static GeneralFormRequiredError = 'This field is required.';
  static Colors: {[key: string]: {hex?: string, rgb?: string}} = {
    primary: {hex: '#4D9BE8'},
    red: {hex: '#f44336'},
    gray1: {hex: '#F8F8F8'},
    gray3: {hex: '#ECECED'},
    gray4: {hex: '#CCCCCC'},
    cold4: {hex: '#D1E7FD'}
  }
  static Margin = 4;
}
